import styled from 'styled-components';

export const ProductsStyled = styled.div`
  position: relative;
  margin: 0;
  background-color: #ffffff;
`;
